<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <form [formGroup]="addForm" enctype="multipart/form-data">
      <div class="form-group">
        <label>اســم الصلاحية</label>
        <input
          formControlName="type"
          [class.is-invalid]="type.invalid && type.touched"
          type="text"
          class="form-control"
        />
        <div *ngIf="type.errors && type.invalid && type.touched">
          <small class="text-danger" *ngIf="type.errors?.required">
            اسم الصلاحية مطلوب
          </small>
        </div>
      </div>
      <input
        type="submit"
        class="add btn btn-primary mt-2"
        value="إضافة"
        (click)="submit()"
      />
    </form>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>
